import { DatapointPerformancePeriodEnum, DatapointsEntityType } from "api/ux/src";
import { performancePeriodLessThanOrEqual } from "common/types/performancePeriod";
import { DataGranularity } from "store/current-dashboard/types";
const shouldNotDisplayTabBasedOnPerformancePeriod = (elements, dataGranularity, periodOfAnalysis) => {
    if (elements === undefined || elements.length === 0) {
        return false;
    }
    if (elements.some((d) => d.periods !== undefined && d.periods > 1)) {
        return false;
    }
    const elementsWithPerfPeriods = elements.filter((d) => d.performancePeriod !== undefined);
    if (elementsWithPerfPeriods?.length > 0 && elementsWithPerfPeriods.every((d) => d.performancePeriod === DatapointPerformancePeriodEnum.OneQuarter)) {
        return true;
    }
    if (elementsWithPerfPeriods?.length > 0 && elementsWithPerfPeriods
        .every((d) => dataGranularity === DataGranularity.yearly &&
        d.performancePeriod !== undefined && performancePeriodLessThanOrEqual(d.performancePeriod, DatapointPerformancePeriodEnum.OneYear))) {
        return true;
    }
    if (periodOfAnalysis === DatapointPerformancePeriodEnum.OneQuarter) {
        return true;
    }
    return periodOfAnalysis !== undefined &&
        performancePeriodLessThanOrEqual(periodOfAnalysis, DatapointPerformancePeriodEnum.OneYear) && dataGranularity === DataGranularity.yearly;
};
const shouldNotDisplayFundTab = (widgetParams, entityType, hasProjected, dataGranularity, periodOfAnalysis, isComparisonWidget, isPacingTimeserie) => {
    const fundDatapoints = widgetParams?.[0]?.measures?.filter((measure) => measure.standardDatapoint?.startsWith("Fund"));
    const situationsWhereToNotDisplay = [
        hasProjected,
        entityType === DatapointsEntityType.Fund,
        fundDatapoints?.length === 0,
        fundDatapoints?.every((d) => d.periods === 1) && !isComparisonWidget,
        shouldNotDisplayTabBasedOnPerformancePeriod(fundDatapoints, dataGranularity, periodOfAnalysis),
        isPacingTimeserie
    ];
    return situationsWhereToNotDisplay.some((s) => s);
};
const shouldNotDisplayAssetTab = (widgetParams, entityType, hasProjected, dataGranularity, periodOfAnalysis, isComparisonWidget, isPacingTimeserie) => {
    const assetDatapoints = widgetParams?.[0]?.measures?.filter((measure) => measure.standardDatapoint?.startsWith("Asset") ||
        measure.standardDatapoint?.startsWith("Instrument"));
    const situationsWhereToNotDisplay = [
        hasProjected,
        entityType === DatapointsEntityType.Asset,
        assetDatapoints?.length === 0,
        assetDatapoints?.every((m) => m.periods === 1) && !isComparisonWidget,
        shouldNotDisplayTabBasedOnPerformancePeriod(assetDatapoints, dataGranularity, periodOfAnalysis),
        isPacingTimeserie
    ];
    return situationsWhereToNotDisplay.some((s) => s);
};
export const shouldNotDisplayLevelTab = ({ dataGranularity, entityType, hasProjected, isComparisonWidget, isPacingTimeserie, level, periodOfAnalysis, widgetParams }) => {
    if (level === "Asset" && shouldNotDisplayAssetTab(widgetParams, entityType, hasProjected, dataGranularity, periodOfAnalysis, isComparisonWidget, isPacingTimeserie)) {
        return true;
    }
    if (level === "Fund" && shouldNotDisplayFundTab(widgetParams, entityType, hasProjected, dataGranularity, periodOfAnalysis, isComparisonWidget, isPacingTimeserie)) {
        return true;
    }
    if (level === "Cashflows" && (!hasProjected || entityType === "Fund" || entityType === "Portfolio")) {
        return true;
    }
    if (level === "ActualsAndProjections" || level === "CommitmentPacingOutputs") {
        return !isPacingTimeserie;
    }
    return level === "Portfolio" && (entityType !== "Portfolio" || !isComparisonWidget);
};
